import { postOrdersIdRegenerateInvoice } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { getOrderDetailQueryKey } from "Order/Api/Query/useOrderDetailQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const invoiceMutationsResource = Resources.base.invoice.mutation;

export const useRegenerateInvoice = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(() => postOrdersIdRegenerateInvoice(orderId)),
		onError: (error) => {
			console.error(
				`${t(invoiceMutationsResource.updateInvoiceError)}:`,
				error,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: getOrderDetailQueryKey(orderId),
			});
			toast.success(t(invoiceMutationsResource.updateInvoiceSuccess));
		},
	});
};
